import { render } from "./CommunityConfirm.vue?vue&type=template&id=7f565689&scoped=true"
import script from "./CommunityConfirm.vue?vue&type=script&lang=js"
export * from "./CommunityConfirm.vue?vue&type=script&lang=js"

import "./CommunityConfirm.vue?vue&type=style&index=0&id=7f565689&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f565689"]])

export default __exports__